<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <div class="m-b-24">
        <!-- <el-button type="primary" size="small" @click="initSensitiveIndex">初始化敏感词到本地</el-button> -->
        <!-- <el-button type="primary" size="small" @click="searchSensitiveIndexAll">检查所有模板</el-button> -->
        <el-button type="primary" size="small" @click="addLuceneSetingBu">添加敏感词</el-button>
      </div>
      <el-form size="small" label-width="100px" class="margin15-tb">
         <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="敏感词:">
              <el-input v-model="searchText" placeholder="请输入敏感词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" size="mini" @click="searchSensitiveWords">搜索</el-button>
          </el-col>
         </el-row>
      </el-form>
    </div>
    <div class="padding15 bg-content">
      <el-table
        size="small"
        v-loading="loading"
        :data="list"
        border
        :row-style="{cursor: 'pointer'}"
        highlight-current-row>
        <el-table-column
          property="id"
          label="序号"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="sensitiveWord"
          label="敏感词"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="createUserName"
          label="创建人"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="updateUserName"
          label="修改人"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="createTime"
          label="添加时间"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="updateTime"
          label="修改时间"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="id"
          label="操作"
          header-align="center"
          align="center">
           <template slot-scope="scope">
             <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editLuceneSetingBu(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteSensitiveIndex(scope.row.id)"></el-button>
          </template>
        </el-table-column>
       </el-table>
       <div class="text center margin15-tb">
          <el-pagination
            background
            layout="prev, pager, next, sizes, total"
            :page-sizes="[50, 100, 200]"
            :total="luceneSeting.totalRecords"
            :page-size="luceneSeting.limit"
            :current-page="luceneSeting.page"
            @current-change="currentChange"
            @size-change="sizeChange">
          </el-pagination>
        </div>
    </div>
    <div class="dialog">
      <el-dialog
        :title= this.title
        :visible.sync="addLuceneSeting"
        width="40%"
        center>
        <el-form>
          <el-input v-model="addText" placeholder="请输入敏感词"></el-input>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="addLuceneSeting = false" size="small">取消</el-button>
          <el-button type="primary" @click="addSensitiveIndex" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchText: null,
      addText: null,
      list: [],
      luceneSeting: {
        totalRecords: 0,
        limit: 50,
        page: 1
      },
      addLuceneSeting: false,
      loading: false,
      title: null,
      sensitiveWordId: null
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    currentChange(page) {
      console.warn('选页');
      this.luceneSeting.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      console.warn('每页条数');
      this.luceneSeting.limit = num;
      this.getList();
    },
    // 搜索
    searchSensitiveWords() {
      this.luceneSeting.totalRecords = 0;
      this.luceneSeting.limit = 50;
      this.luceneSeting.page = 1;
      this.getList();
    },
    addLuceneSetingBu() {
      this.title = '添加敏感词';
      this.addText = null;
      this.sensitiveWordId = null;
      this.addLuceneSeting = true;
    },
    editLuceneSetingBu(row) {
      this.title = '编辑敏感词';
      this.addText = row.sensitiveWord;
      this.sensitiveWordId = row.id;
      this.addLuceneSeting = true;
    },
    // 添加/编辑敏感词
    addSensitiveIndex() {
      if (!this.addText) {
        this.$notify.error({
          message: '敏感词不能为空!'
        });
        return;
      }
      const search = {};
      search.sensitiveWordId = this.sensitiveWordId;
      search.sensitiveWord = this.addText;
      this.$ajax({
        prompt: true,
        url: '/lucene/addSensitiveIndex',
        data: search
      }).then(() => {
        this.addLuceneSeting = false;
        this.getList();
      });
    },
    // 删除敏感词
    deleteSensitiveIndex(sensitiveWordId) {
      this.$confirm('是否确定删除此敏感词?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/lucene/deleteSensitiveIndex',
          params: { 'sensitiveWordId': sensitiveWordId }
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getList();
        }).catch((error) => {
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getList() {
      this.loading = true;
      const search = this.luceneSeting;
      search.sensitiveWord = this.searchText;
      this.$ajax({
        url: '/lucene/getList',
        data: search
      }).then((res) => {
        this.list = res.data.list;
        this.luceneSeting.totalRecords = res.data.totalRecords;
        this.loading = false;
      }).catch(() => {
        this.loading = true;
      });
    },
    // 检查所有模版
    searchSensitiveIndexAll() {
      this.$confirm('确定检查所有模版?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$ajax({
          url: '/lucene/searchSensitiveIndexAll'
        }).then((res) => {
          this.loading = false;
          if (res.data) {
            this.$notify.error({
              type: 'error',
              message: res.data
            });
          } else {
            this.$notify({
              message: '模版内容不包含任何敏感词',
              type: 'success'
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/algCorpus/robotLuceneSetting.vue